import React from 'react';
import './UndetectableSection.css';

const PLATFORMS = [
  { name: 'Zoom', color: '#2D8CFF' },
  { name: 'Microsoft Teams', color: '#6264A7' },
  { name: 'Google Meet', color: '#00897B' },
  { name: 'Amazon Chime', color: '#FF9900' },
  { name: 'Cisco Webex', color: '#005073' },
  { name: 'HackerRank', color: '#00EA64' },
  { name: 'CoderPad', color: '#F26b3A' },
  { name: 'Codility', color: '#4C6BFF' },
];

const UndetectableSection = () => {
  return (
    <div className="undetectable-section">
      <p className="undetectable-eyebrow">Reliability Standard</p>
      <h2 className="undetectable-title">Undetectable.</h2>
      <p className="undetectable-subtitle">Tested daily across every interview app.</p>

      <div className="undetectable-list">
        {PLATFORMS.map((platform) => (
          <div className="undetectable-row" key={platform.name}>
            <span
              className="undetectable-avatar"
              style={{ backgroundColor: platform.color }}
            >
              {platform.name.charAt(0)}
            </span>
            <span className="undetectable-name">{platform.name}</span>
            <span className="undetectable-tested">Tested daily</span>
            <span className="undetectable-badge">
              <span className="undetectable-dot" />
              Undetectable
            </span>
          </div>
        ))}
      </div>

      <p className="undetectable-note">
        Daily testing and real-world checks keep ConvoCue AI fully undetectable.
        Because interview platforms rely on the same screen-share technology,
        it stays invisible everywhere — including almost all other interview software.
      </p>
    </div>
  );
};

export default UndetectableSection;
